import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [statusMsg, setStatusMsg] = useState('');
  const [statusType, setStatusType] = useState<'success' | 'error' | ''>('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      setStatusMsg('请输入邮箱地址');
      setStatusType('error');
      return;
    }
    setStatusMsg('订阅成功！感谢关注皮皮漫画');
    setStatusType('success');
    setEmail('');
    setTimeout(() => {
      setStatusMsg('');
      setStatusType('');
    }, 3000);
  };

  return (
    <footer id="footer" className="bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-open-line text-lg text-white"></i>
                </div>
                <span className="text-lg font-heading text-foreground-950">皮皮漫画</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                皮皮漫画🎯提供韩漫、日漫、国漫等多种类型漫画在线免费阅读。皮皮漫画韩漫专区与皮皮漫画日漫专区一应俱全，
                每日更新不断档，是漫画爱好者的最佳选择。
              </p>
              <form onSubmit={handleSubmit} className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱订阅更新"
                  className="flex-1 px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 transition-colors"
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  订阅
                </button>
              </form>
              {statusMsg && (
                <p className={`text-xs mt-2 ${statusType === 'success' ? 'text-accent-600' : 'text-primary-600'}`}>
                  {statusMsg}
                </p>
              )}
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {[
                  { label: '热门榜单', href: '#ranking' },
                  { label: '精选推荐', href: '#cards' },
                  { label: '焦点专题', href: '#carousel' },
                  { label: '最新动态', href: '#updates' },
                  { label: '常见问答', href: '#faq' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">漫画分类</h4>
              <ul className="space-y-2.5">
                {['韩漫推荐', '日漫新番', '国漫精选', '恋爱甜漫', '热血战斗', '悬疑推理'].map((cat) => (
                  <li key={cat}>
                    <a
                      href="#index"
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {cat}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li>
                  <a href="#about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    平台介绍
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    联系我们
                  </a>
                </li>
                <li>
                  <a href="#faq" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    常见问题
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-200 mt-10 pt-6">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} 皮皮漫画 - 韩漫日漫国漫在线免费阅读平台
              </p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-foreground-500 font-medium">合作伙伴</span>
                <span className="text-xs text-foreground-400">虚位以待</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}